module.exports = "<p>complementos-pagos works!</p>\n"